import script from "./lBarCs.vue?vue&type=script&setup=true&lang=ts"
export * from "./lBarCs.vue?vue&type=script&setup=true&lang=ts"

import "./lBarCs.vue?vue&type=style&index=0&id=6b9def6d&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b9def6d"]])

export default __exports__